import {
	Directive,
	OnDestroy,
	OnInit,
	TemplateRef,
	ViewContainerRef,
} from '@angular/core';
import { SubSink } from 'subsink';

// --- Facades ---
import { AuthFacade } from '@facades/auth.facade';

@Directive({
	selector: '[appDisableIfVisitor]',
})
export class DisableIfVisitorDirective implements OnInit, OnDestroy {
	readonly authState$ = this.authFacade.authState$;
	private subs = new SubSink();

	constructor(
		private authFacade: AuthFacade,
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef
	) {}

	ngOnInit() {
		this.subs.add(
			this.authFacade.authState$.subscribe(({ isAuthenticated }) => {
				this.viewContainer.remove();
				if (isAuthenticated) {
					this.viewContainer.createEmbeddedView(this.templateRef);
				} else {
					this.viewContainer.clear();
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}
}
